import React from 'react';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const GLOBAL_INFO =
  'These instructions tell the AI how to use the client’s sources together with the card-specific instructions to generate a structured Company Profile. They are Admin-only and are never shown to Clients or Lead Agents.';

const GlobalInstructionsPanel = ({ onEdit }) => (
  <Box
    border={1}
    borderColor='divider'
    borderRadius={2}
    p={2}
    mb={3}
    bgcolor='#f8fafc'
  >
    <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={2}>
      <Box display='flex' alignItems='center' gap={0.75}>
        <Typography variant='subtitle1' fontWeight={700}>
          Global Company Profile generation instructions
        </Typography>
        <Tooltip
          title={GLOBAL_INFO}
          arrow
          placement='top'
          slotProps={{ tooltip: { sx: { maxWidth: 360 } } }}
        >
          <IconButton size='small' aria-label='About global instructions' sx={{ color: 'text.secondary' }}>
            <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Button
        variant='outlined'
        size='small'
        startIcon={<EditOutlinedIcon />}
        onClick={onEdit}
        sx={{ textTransform: 'none', flexShrink: 0 }}
      >
        Edit global instructions
      </Button>
    </Box>
  </Box>
);

export default GlobalInstructionsPanel;
